// extracted by css-extract-rspack-plugin
export default {"input":"UiInput_input_uwI0M","error":"UiInput_error_oYAGu"};